<template>
  <div class="crm-page">
    <div class="tm-workbench">
      <div class="tm-header tm-toolbar">
        <div class="tm-title-row">
          <div class="crm-eyebrow">客户管理CRM</div>
          <h2>电销工作台</h2>
          <div class="tm-stats">
            <span>待拨资源 <b>{{ queueStats.remaining || 0 }}</b></span>
            <span>待重拨 <b>{{ queueStats.requeue || 0 }}</b></span>
            <span>AI新增 <b>{{ queueStats.ai || 0 }}</b></span>
            <span>今日已拨 <b>{{ queueStats.todayCalled || 0 }}</b></span>
          </div>
        </div>
        <div class="tm-actions">
          <input
            ref="tmFile"
            type="file"
            accept=".xlsx,.xls"
            style="display: none"
            @change="handleTeleFilePick"
          />
          <el-button size="small" icon="el-icon-download" @click="downloadTemplate">下载模板</el-button>

          <el-button
            size="small"
            type="primary"
            icon="el-icon-upload2"
            :loading="tm.importing"
            @click="$refs.tmFile.click()"
            >导入 Excel</el-button
          >
          <el-button
            size="small"
            icon="el-icon-refresh"
            :loading="tm.loading"
            @click="loadTeleItems"
            >刷新</el-button
          >
        </div>
      </div>
      <el-alert
        v-if="tm.lastBatch.batchNo"
        type="success"
        :closable="false"
        show-icon
        :title="
          '当前批次：' +
          tm.lastBatch.batchNo +
          '，已生成 ' +
          tm.items.length +
          ' 条拨打任务'
        "
      />
      <div class="tm-body">
        <el-card class="tm-list" shadow="never">
          <div slot="header" class="tm-card-header">
            <span>拨打名单（剩余 {{ queueStats.remaining || filteredTeleItems.length }} 条）</span>
            <el-select
              v-model="tm.status"
              size="mini"
              clearable
              placeholder="全部状态"
              style="width: 132px"
              @change="loadTeleItems"
            >
              <el-option label="全部" value="" />
              <el-option label="待拨打" value="待拨打" />
              <el-option label="待重拨" value="待重拨" />
              <el-option label="AI新增待拨" value="AI新增待拨" />
              <el-option label="已发起" value="已发起" />
              <el-option label="已跳过" value="已跳过" />
            </el-select>
          </div>
          <el-input
            v-model.trim="tm.keyword"
            size="small"
            placeholder="搜索姓名/电话/公司"
            clearable
            class="tm-search"
          />
          <el-select
            v-model="tm.queueSource"
            size="small"
            clearable
            placeholder="全部来源"
            style="width:100%;margin-bottom:6px"
            @change="filterTeleItems"
          >
            <el-option label="全部来源" value="" />
            <el-option label="公海池转入" value="public_pool" />
            <el-option label="Excel自导入" value="excel" />
            <el-option label="待重拨" value="requeue" />
            <el-option label="AI新增" value="ai" />
          </el-select>
          <el-table
            :data="visibleTeleItems"
            size="small"
            highlight-current-row
            v-loading="tm.loading"
            @row-click="selectTeleItem"
          >
            <el-table-column type="index" width="45" />
            <el-table-column label="客户" min-width="160">
              <template slot-scope="s"><b>{{ s.row.name || s.row.companyName || "-" }}</b>
                <div class="muted">{{ s.row.companyName && s.row.name ? s.row.companyName : (s.row.legalPersonName || "-") }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="手机号" width="120" />
            <el-table-column label="来源" width="80">
              <template slot-scope="s">
                <el-tag size="mini" :type="s.row.queueSource === 'public_pool' ? 'success' : 'info'">
                  {{ s.row.queueSource === 'public_pool' ? '公海' : (s.row.queueSource === 'ai' ? 'AI' : 'Excel') }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="88">
              <template slot-scope="s"><el-tag size="mini">{{ s.row.callStatus }}</el-tag></template>
            </el-table-column>
          </el-table>
          <div v-if="hiddenTeleItemCount > 0" class="tm-list-fold">
            <span>已默认显示 30 条，剩余 {{ hiddenTeleItemCount }} 条已折叠</span>
            <el-button type="text" size="mini" @click="tm.showAllItems = !tm.showAllItems">
              {{ tm.showAllItems ? '收起' : '展开全部' }}
            </el-button>
          </div>

        </el-card>
        <el-card class="tm-detail" shadow="never">
          <div slot="header" class="tm-card-header">
            <span>客户详情与拨打区</span
            ><span v-if="currentTeleItem" class="muted"
              >任务 #{{ currentTeleItem.id }}</span
            >
          </div>
          <el-empty
            v-if="!currentTeleItem"
            description="请先导入 Excel 或选择左侧客户"
          />
          <template v-else>
            <!-- 来源标签 -->
            <div class="tm-source-badge" style="margin-bottom:10px">
              <el-tag v-if="currentTeleItem.queueSource === 'public_pool'" type="success" size="small" icon="el-icon-s-home">公海池转入</el-tag>
              <el-tag v-else-if="currentTeleItem.queueSource === 'ai'" type="warning" size="small">AI新增</el-tag>
              <el-tag v-else type="info" size="small">Excel自导入</el-tag>
            </div>
            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="姓名">{{ currentTeleItem.name }}</el-descriptions-item>
              <el-descriptions-item label="手机号">{{ currentTeleItem.phone }}</el-descriptions-item>
              <el-descriptions-item label="公司">{{ currentTeleItem.companyName || "-" }}</el-descriptions-item>
              <el-descriptions-item label="法人">{{ currentTeleItem.legalPersonName || "-" }}</el-descriptions-item>
              <el-descriptions-item label="公司地址" :span="2">{{ currentTeleItem.companyAddress || "-" }}</el-descriptions-item>
              <el-descriptions-item label="地区">{{ currentTeleItem.region || "-" }}</el-descriptions-item>
              <el-descriptions-item label="问题类型">{{ currentTeleItem.issueType || "-" }}</el-descriptions-item>
              <el-descriptions-item label="拨打次数">{{ currentTeleItem.callCount || 0 }}</el-descriptions-item>
              <!-- 公海资源画像字段 -->
              <template v-if="currentTeleItem.queueSource === 'public_pool' && tm.detail">
                <el-descriptions-item v-if="tm.detail.enterpriseScale" label="企业规模">{{ tm.detail.enterpriseScale }}</el-descriptions-item>
                <el-descriptions-item v-if="tm.detail.tianyanScore > 0" label="天眼评分">
                  <span style="color:#e6a23c;font-weight:700">{{ tm.detail.tianyanScore }}</span>
                </el-descriptions-item>
                <el-descriptions-item v-if="tm.detail.industryBig" label="行业大类" :span="2">{{ tm.detail.industryBig }}</el-descriptions-item>
                <el-descriptions-item v-if="tm.detail.registerStatus" label="登记状态">{{ tm.detail.registerStatus }}</el-descriptions-item>
                <el-descriptions-item v-if="tm.detail.registeredCapital" label="注册资本">{{ tm.detail.registeredCapital }}</el-descriptions-item>
                <el-descriptions-item v-if="tm.detail.extraPhones && tm.detail.extraPhones.length" label="更多电话" :span="2">
                  {{ tm.detail.extraPhones.join(' / ') }}
                </el-descriptions-item>
                <el-descriptions-item v-if="tm.detail.businessScope" label="经营范围" :span="2">
                  <span class="tm-scope-text">{{ tm.detail.businessScope.slice(0, 120) }}{{ tm.detail.businessScope.length > 120 ? '…' : '' }}</span>
                </el-descriptions-item>
              </template>
            </el-descriptions>
            <el-alert v-if="tm.recentWarning" class="tm-warning" type="warning" show-icon :closable="false" :title="tm.recentWarning" />
            <el-tabs class="tm-history" v-loading="tm.detailLoading">
              <el-tab-pane label="历史拨打">
                <el-table :data="tm.callRecords" size="mini" empty-text="暂无历史拨打记录">
                  <el-table-column prop="callStartTime" label="拨打时间" width="150" />
                  <el-table-column prop="employeeName" label="员工" width="90" />
                  <el-table-column prop="callStatus" label="状态" width="90" />
                  <el-table-column label="时长" width="90"><template slot-scope="s">{{ formatTeleDuration(s.row.duration) }}</template></el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="共享跟进">
                <el-table :data="tm.followRecords" size="mini" empty-text="暂无历史跟进记录">
                  <el-table-column prop="followTime" label="跟进时间" width="150" />
                  <el-table-column prop="employeeName" label="跟进人" width="90" />
                  <el-table-column prop="result" label="结果" width="100" />
                  <el-table-column prop="summary" label="摘要" min-width="180" show-overflow-tooltip />
                </el-table>
              </el-tab-pane>
            </el-tabs>

            <div class="tm-callbar">
              <el-button @click="moveTele(-1)">上一条</el-button>
              <el-button
                type="success"
                icon="el-icon-phone"
                :loading="tm.calling"
                @click="callTeleItem"
                >一键呼叫</el-button
              >
              <el-button @click="skipTeleItem">暂时跳过</el-button>
              <el-button
                type="primary"
                :loading="tm.completing"
                @click="completeTeleItem"
                >完成并下一条</el-button
              >
              <el-button
                v-if="currentTeleItem && currentTeleItem.queueSource === 'public_pool'"
                type="warning"
                plain
                size="small"
                :loading="tm.returning"
                @click="returnToPublicPool"
                >退回公海</el-button
              >
            </div>
            <el-divider content-position="left">快速跟进</el-divider>
            <el-form :model="tm.follow" label-width="96px" size="small">
              <el-form-item label="跟进结果"
                ><el-select v-model="tm.follow.result" style="width: 220px"
                  ><el-option
                    v-for="r in quickFollowResults"
                    :key="r"
                    :label="r"
                    :value="r" /></el-select
              ></el-form-item>
              <el-form-item label="意向等级"
                ><el-select
                  v-model="tm.follow.intentionLevel"
                  style="width: 220px"
                  ><el-option
                    v-for="l in options.intentionLevels"
                    :key="l"
                    :label="l"
                    :value="l" /></el-select
              ></el-form-item>
              <el-form-item label="下次跟进"
                ><el-date-picker
                  v-model="tm.follow.nextFollowTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择时间"
              /></el-form-item>
              <el-form-item label="备注"
                ><el-input
                  v-model="tm.follow.summary"
                  type="textarea"
                  :rows="3"
                  placeholder="记录本次沟通情况"
              /></el-form-item>
              <el-form-item
                ><el-button
                  type="primary"
                  :loading="tm.savingFollow"
                  @click="saveTeleFollow"
                  >保存跟进</el-button
                ></el-form-item
              >
            </el-form>
          </template>
        </el-card>
        <el-card class="tm-ai" shadow="never">
          <div slot="header" class="tm-card-header">
            <span>AI 找号助手</span>
            <el-button size="mini" type="primary" :loading="tm.ai.searching" :disabled="!currentTeleItem" @click="searchAiPhoneLeads">AI找号</el-button>
          </div>
          <el-empty v-if="!currentTeleItem" description="请选择客户后使用AI找号" />
          <template v-else>
            <div class="ai-base">
              <b>{{ currentTeleItem.companyName || currentTeleItem.name }}</b>
              <span>{{ currentTeleItem.legalPersonName || '-' }} / {{ currentTeleItem.companyAddress || '-' }}</span>
            </div>
            <el-table :data="tm.ai.leads.slice(0, 3)" size="mini" class="ai-table" empty-text="暂无AI电话线索">
              <el-table-column label="线索" min-width="160">
                <template slot-scope="s">
                  <b class="ai-phone-only">{{ s.row.phone }}</b>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="90">
                <template slot-scope="s">
                  <el-button type="text" size="mini" @click="callAiLead(s.row)">拨号</el-button>
                  <el-button type="text" size="mini" @click="joinAiLeadQueue(s.row)">入队</el-button>
                  <el-button type="text" size="mini" @click="saveAiLead(s.row)">保存</el-button>
                  <el-button type="text" size="mini" @click="ignoreAiLead(s.row)">忽略</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div v-if="tm.ai.leads.length" class="ai-more-bar">
              <span>已查询到 {{ tm.ai.leads.length }} 条线索，当前仅展示前 3 条</span>
              <el-button type="text" size="mini" @click="openAiLeadDetail">更多详情</el-button>
            </div>

          </template>
        </el-card>

      </div>
    </div>

    <div v-if="false" class="crm-hero">
      <div>
        <div class="crm-eyebrow">客户管理CRM</div>
        <h2>客户登记</h2>
        <p>
          支持单条录入、Excel
          导入预检、重复校验演示、导入确认和未导入原因查看。当前为纯前端 mock
          版本。
        </p>
      </div>
      <div class="crm-actions">
        <el-radio-group v-model="mode" size="small">
          <el-radio-button label="single">单条录入</el-radio-button>
          <el-radio-button label="import">Excel 导入</el-radio-button>
        </el-radio-group>
        <el-button icon="el-icon-refresh-left" @click="restoreDemo"
          >恢复演示数据</el-button
        >
      </div>
    </div>

    <template v-if="false">
      <el-card shadow="never">
        <div slot="header" class="card-header">
          <span>基本资料</span>
          <el-tag size="mini" type="info">保存为前端演示</el-tag>
        </div>
        <el-row :gutter="16">
          <el-col :span="6"
            ><el-input
              v-model.trim="form.name"
              placeholder="客户姓名"
            ></el-input
          ></el-col>
          <el-col :span="6">
            <el-select
              v-model="form.gender"
              placeholder="性别"
              style="width: 100%"
            >
              <el-option label="男" value="男"></el-option>
              <el-option label="女" value="女"></el-option>
              <el-option label="未知" value="未知"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6"
            ><el-input
              v-model.trim="form.phone"
              placeholder="手机号"
              @blur="checkDuplicate"
            ></el-input
          ></el-col>
          <el-col :span="6"
            ><el-input
              v-model.trim="form.backupPhone"
              placeholder="备用电话"
            ></el-input
          ></el-col>
        </el-row>
        <el-row :gutter="16" style="margin-top: 12px">
          <el-col :span="6"
            ><el-input
              v-model.trim="form.wechat"
              placeholder="微信号"
            ></el-input
          ></el-col>
          <el-col :span="6"
            ><el-input
              v-model.trim="form.companyName"
              placeholder="公司名称"
            ></el-input
          ></el-col>
          <el-col :span="6"
            ><el-input
              v-model.trim="form.jobTitle"
              placeholder="职务"
            ></el-input
          ></el-col>
          <el-col :span="6"
            ><el-input
              v-model.trim="form.region"
              placeholder="地区，如 福建-福州"
            ></el-input
          ></el-col>
        </el-row>
        <el-row :gutter="16" style="margin-top: 12px">
          <el-col :span="6">
            <el-select
              v-model="form.source"
              placeholder="来源"
              style="width: 100%"
            >
              <el-option
                v-for="item in options.sources"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select
              v-model="form.sourceDetail"
              placeholder="来源明细"
              style="width: 100%"
            >
              <el-option
                v-for="item in options.sourceDetails"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="12"
            ><el-input
              v-model.trim="form.serviceNeed"
              placeholder="服务需求"
            ></el-input
          ></el-col>
        </el-row>
      </el-card>

      <el-card shadow="never">
        <div slot="header" class="card-header">
          <span>业务资料</span>
          <el-tag size="mini" type="danger">案件纠纷类型必须确认</el-tag>
        </div>
        <el-row :gutter="16">
          <el-col :span="6">
            <el-select
              v-model="form.issueType"
              placeholder="问题类型"
              style="width: 100%"
            >
              <el-option
                v-for="item in options.issueTypes"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select
              v-model="form.disputeType"
              placeholder="纠纷类型"
              style="width: 100%"
              @change="applyDisputeSchema"
            >
              <el-option
                v-for="item in options.disputeTypes"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4"
            ><el-input
              v-model="form.caseAmount"
              placeholder="案件金额"
            ></el-input
          ></el-col>
          <el-col :span="6"
            ><el-input
              v-model.trim="form.painPoint"
              placeholder="客户当前痛点"
            ></el-input
          ></el-col>
        </el-row>
        <div class="selected-dispute" v-if="form.disputeType">
          <span>当前案件纠纷类型：</span>
          <b>{{ form.disputeType }}</b>
        </div>
        <el-row :gutter="16" style="margin-top: 12px">
          <el-col
            v-for="field in disputeFieldsSchema"
            :key="field.prop"
            :span="field.type === 'textarea' ? 24 : 8"
            style="margin-bottom: 12px"
          >
            <el-input
              v-if="field.type === 'input'"
              v-model="form.disputeFields[field.prop]"
              :placeholder="field.label"
            />
            <el-select
              v-else-if="field.type === 'select'"
              v-model="form.disputeFields[field.prop]"
              :placeholder="field.label"
              style="width: 100%"
            >
              <el-option
                v-for="item in field.options"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-date-picker
              v-else-if="field.type === 'date'"
              v-model="form.disputeFields[field.prop]"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="field.label"
              style="width: 100%"
            />
            <el-radio-group
              v-else-if="field.type === 'radio'"
              v-model="form.disputeFields[field.prop]"
            >
              <el-radio
                v-for="item in field.options"
                :key="item"
                :label="item"
                >{{ item }}</el-radio
              >
            </el-radio-group>
            <el-input
              v-else
              type="textarea"
              :rows="3"
              v-model="form.disputeFields[field.prop]"
              :placeholder="field.label"
            />
          </el-col>
        </el-row>
        <el-input
          type="textarea"
          :rows="3"
          v-model="form.remark"
          placeholder="备注"
        ></el-input>
      </el-card>

      <el-card shadow="never">
        <div slot="header" class="card-header">
          <span>初始跟进信息</span>
          <el-tag size="mini" type="warning">当前仅模拟保存</el-tag>
        </div>
        <el-row :gutter="16">
          <el-col :span="4">
            <el-switch
              v-model="form.firstCallDone"
              active-text="已首呼"
              inactive-text="未首呼"
            ></el-switch>
          </el-col>
          <el-col :span="6">
            <el-select
              v-model="form.firstCallResult"
              placeholder="首呼结果"
              style="width: 100%"
            >
              <el-option
                v-for="item in options.followResults"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-switch
              v-model="form.hasWeChat"
              active-text="已加微信"
              inactive-text="未加微信"
            ></el-switch>
          </el-col>
          <el-col :span="4">
            <el-select
              v-model="form.intentionLevel"
              placeholder="意向等级"
              style="width: 100%"
            >
              <el-option
                v-for="item in options.intentionLevels"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-date-picker
              v-model="form.nextFollowTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="下次跟进时间"
              style="width: 100%"
            />
          </el-col>
        </el-row>
        <div class="form-actions">
          <el-button icon="el-icon-document" @click="saveDraft"
            >保存草稿</el-button
          >
          <el-button type="primary" plain @click="submitSingle(true)"
            >提交并继续录入</el-button
          >
          <el-button type="primary" @click="submitSingle(false)"
            >提交到我的客户</el-button
          >
        </div>
      </el-card>
    </template>

    <template v-if="false">
      <el-card shadow="never">
        <div slot="header" class="card-header">
          <span>Excel 表格导入</span>
          <el-tag size="mini" type="info">支持 xls / xlsx / csv</el-tag>
        </div>
        <el-row :gutter="16">
          <el-col :span="10">
            <div class="import-box">
              <h4>导入入口</h4>
              <div class="import-actions">
                <el-button
                  type="primary"
                  icon="el-icon-download"
                  @click="downloadTemplate"
                  >下载导入模板</el-button
                >
                <el-button icon="el-icon-upload2" @click="triggerUpload"
                  >上传 Excel</el-button
                >
                <el-button icon="el-icon-document" @click="viewLastImport"
                  >查看导入结果</el-button
                >
              </div>
              <input
                ref="excelInput"
                class="hidden-input"
                type="file"
                accept=".xls,.xlsx,.csv"
                @change="handleFilePick"
              />
              <div class="file-name" v-if="importFileName">
                当前文件：{{ importFileName }}
              </div>
            </div>
          </el-col>
          <el-col :span="14">
            <div class="template-box">
              <h4>模板字段说明</h4>
              <div class="template-tags">
                <el-tag
                  v-for="item in templateFields"
                  :key="item"
                  size="mini"
                  effect="plain"
                  >{{ item }}</el-tag
                >
              </div>
              <ul>
                <li>默认按手机号做唯一主键进行去重。</li>
                <li>
                  与公海池、其他员工客户、我自己的客户重复时，默认不导入。
                </li>
                <li>导入文件内部重复时，只保留第一条，其余判定为未导入。</li>
                <li>当前阶段仅演示前端预检与导入确认，不接真实后台。</li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </el-card>

      <el-card v-if="importResult" shadow="never">
        <div slot="header" class="card-header">
          <span>数据预检结果</span>
          <el-tag size="mini" type="warning"
            >点击确认后，仅导入完全新客户</el-tag
          >
        </div>
        <div class="result-stats">
          <div
            v-for="item in resultStatCards"
            :key="item.label"
            class="result-card"
          >
            <span>{{ item.label }}</span>
            <strong>{{ item.value }}</strong>
          </div>
        </div>
        <div class="confirm-tip">
          点击确认导入后，只会把校验通过且不重复的数据导入到“我的客户”；所有重复数据和异常数据都不会导入。
        </div>
        <div class="form-actions" style="margin-top: 16px">
          <el-button @click="clearImportResult">清空本次结果</el-button>
          <el-button type="primary" @click="confirmImport"
            >确认导入 {{ importResult.summary.importable }} 条</el-button
          >
        </div>
      </el-card>

      <el-row v-if="importResult" :gutter="16">
        <el-col :span="12">
          <el-card shadow="never">
            <div slot="header" class="card-header">
              <span>可导入数据预览</span>
              <el-tag size="mini" type="success"
                >{{ importResult.accepted.length }} 条</el-tag
              >
            </div>
            <el-table :data="importResult.accepted.slice(0, 8)" border stripe>
              <el-table-column
                prop="name"
                label="姓名"
                min-width="120"
              ></el-table-column>
              <el-table-column label="手机号" min-width="160">
                <template slot-scope="scope">
                  <crm-phone-field :phone="scope.row.phone" status="pending" />
                </template>
              </el-table-column>
              <el-table-column
                prop="companyName"
                label="公司名称"
                min-width="160"
              ></el-table-column>
              <el-table-column
                prop="companyAddress"
                label="公司地址"
                min-width="180"
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card shadow="never">
            <div slot="header" class="card-header">
              <span>未导入原因列表</span>
              <el-tag size="mini" type="danger"
                >{{ importResult.rejected.length }} 条</el-tag
              >
            </div>
            <el-table :data="importResult.rejected.slice(0, 8)" border stripe>
              <el-table-column
                prop="name"
                label="姓名"
                min-width="100"
              ></el-table-column>
              <el-table-column label="手机号" min-width="160">
                <template slot-scope="scope">
                  <crm-phone-field :phone="scope.row.phone" status="failed" />
                </template>
              </el-table-column>
              <el-table-column
                prop="companyName"
                label="公司名称"
                min-width="130"
              ></el-table-column>
              <el-table-column
                prop="reason"
                label="未导入原因"
                min-width="140"
              ></el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </template>

    <el-dialog
      :visible.sync="aiDetailVisible"
      width="980px"
      top="5vh"
      custom-class="ai-detail-dialog"
      :append-to-body="true"
      title="AI找号详情"
    >
      <div v-loading="aiDetailLoading" class="ai-detail-window">
        <div class="ai-detail-simple-grid">
          <div class="simple-row"><span>公司名称</span><b>{{ aiDetailItem.companyName || aiDetailCustomer.companyName || '-' }}</b></div>
          <div class="simple-row"><span>法定代表人</span><b>{{ aiDetailItem.legalPersonName || aiDetailCustomer.legalPersonName || '-' }}</b></div>
          <div class="simple-row"><span>统一社会信用代码</span><b>{{ firstAiDetail.unifiedSocialCreditCode || '-' }}</b></div>
          <div class="simple-row"><span>经营范围</span><b>{{ shortBusinessScope || '-' }}</b></div>
        </div>
        <el-card shadow="never" class="ai-detail-card">
          <b>联系电话</b>
          <div class="phone-tags">
            <el-tag v-for="lead in aiDetailLeads" :key="lead.id || lead.phone" size="small" type="success">{{ lead.phone }}</el-tag>
          </div>
        </el-card>
        <el-card shadow="never" class="ai-detail-card">
          <b>司法案件 / 案号 / 执行 / 开庭 / 裁判文书</b>
          <p>{{ mergedJudicialInfo || '暂无' }}</p>
        </el-card>
        <el-card shadow="never" class="ai-detail-card">
          <b>经营风险</b>
          <p>{{ mergedRiskInfo || '暂无' }}</p>
        </el-card>
      </div>
      <span slot="footer"><el-button @click="aiDetailVisible = false">关闭</el-button></span>
    </el-dialog>


    <el-dialog
      :visible.sync="duplicateVisible"
      width="460px"
      title="检测到重复手机号"
      :append-to-body="true"
    >
      <div class="duplicate-box" v-if="duplicateInfo">
        <p>
          系统检测到手机号
          <b
            ><crm-phone-field :phone="duplicateInfo.phone" status="pending"
          /></b>
          已存在。
        </p>
        <div class="duplicate-line">
          <span>客户姓名</span><b>{{ duplicateInfo.name }}</b>
        </div>
        <div class="duplicate-line">
          <span>当前所属池</span><b>{{ duplicateInfo.poolType }}</b>
        </div>
        <div class="duplicate-line">
          <span>当前归属人</span
          ><b>{{ duplicateInfo.ownerName || "公海池" }}</b>
        </div>
        <div class="duplicate-line">
          <span>当前状态</span><b>{{ duplicateInfo.mainStatus }}</b>
        </div>
        <p class="duplicate-tip">
          当前阶段先做前端提示演示，正式提交会先阻止重复创建。
        </p>
      </div>
      <span slot="footer">
        <el-button @click="duplicateVisible = false">返回修改</el-button>
        <el-button type="primary" plain @click="saveDraftFromDuplicate"
          >仅保存为草稿</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postRequest } from "@/utils/api";

import * as XLSX from "xlsx";
import CrmPhoneField from "./PhoneField.vue";
import {
  buildImportedCustomer,
  CRM_DISPUTE_SCHEMAS,
  CRM_OPTIONS,
  createCustomerId,
  createOperationLog,
  evaluateImportRows,
  loadCrmState,
  normalizePhone,
  resetCrmState,
  saveCrmState,
} from "./mock";

const IMPORT_RESULT_KEY = "fdb-crm-last-import-result";

function emptyForm() {
  return {
    name: "",
    gender: "未知",
    phone: "",
    backupPhone: "",
    wechat: "",
    companyName: "",
    jobTitle: "",
    region: "福建-福州",
    source: "抖音",
    sourceDetail: "短视频私信",
    issueType: "债务催收",
    disputeType: "借贷合同纠纷",
    caseAmount: "",
    serviceNeed: "",
    painPoint: "",
    remark: "",
    firstCallDone: false,
    firstCallResult: "待联系",
    hasWeChat: false,
    intentionLevel: "C低意向",
    nextFollowTime: "",
    disputeFields: {},
  };
}

function formatNow() {
  const now = new Date();
  const pad = (value) => String(value).padStart(2, "0");
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
    now.getDate()
  )} ${pad(now.getHours())}:${pad(now.getMinutes())}`;
}

export default {
  name: "CrmRegistration",
  components: { CrmPhoneField },
  data() {
    const form = emptyForm();
    return {
      options: CRM_OPTIONS,
      state: loadCrmState(this.$store.getters.GET_TITLE || "当前员工"),
      mode: "single",
      form,
      duplicateVisible: false,
      duplicateInfo: null,
      importResult: null,
      importFileName: "",
      aiDetailVisible: false,
      aiDetailLoading: false,
      aiDetailCustomer: {},
      aiDetailItem: {},
      aiDetailLeads: [],

      tm: {

        loading: false,
        importing: false,
        showAllItems: false,

        calling: false,
        savingFollow: false,
        completing: false,
        returning: false,
        items: [],
        currentIndex: -1,
        detailLoading: false,
        detail: null,
        callRecords: [],
        followRecords: [],
        recentWarning: "",

        keyword: "",
        status: "",
        queueSource: "",
        lastBatch: {},
        stats: {
          remaining: 0,
          requeue: 0,
          ai: 0,
          todayCalled: 0,
        },
        follow: {
          result: "有效沟通",
          intentionLevel: "C低意向",
          nextFollowTime: "",
          summary: "",
        },
        ai: {
          searching: false,
          leads: [],
        },
      },
      quickFollowResults: [
        "未接通",
        "有效沟通",
        "已加微信",
        "稍后再打",
        "有意向",
        "无意向",
      ],

      templateFields: [
        "客户姓名",
        "手机号",
        "微信号",
        "公司名称",
        "法人姓名",
        "公司地址",
        "地区",
        "问题类型",
        "备注",
      ],
    };
  },
  computed: {
    firstAiDetail() {
      return (this.aiDetailLeads && this.aiDetailLeads[0]) || {};
    },

    ownerName() {
      return this.$store.getters.GET_TITLE || "当前员工";
    },
    queueStats() {
      const stats = this.tm.stats || {};
      return {
        remaining: Number(stats.remaining || stats.total || this.tm.items.length || 0),
        requeue: Number(stats.requeue || stats.retry || 0),
        ai: Number(stats.ai || stats.aiPending || 0),
        todayCalled: Number(stats.todayCalled || stats.today_call || 0),
      };
    },
    filteredTeleItems() {
      const keyword = (this.tm.keyword || "").toLowerCase();
      const src = this.tm.queueSource || "";
      return this.tm.items.filter((item) => {
        if (src && item.queueSource !== src) return false;
        if (!keyword) return true;
        return [item.name, item.phone, item.companyName, item.legalPersonName]
          .join(" ").toLowerCase().includes(keyword);
      });
    },
    visibleTeleItems() {
      return this.tm.showAllItems ? this.filteredTeleItems : this.filteredTeleItems.slice(0, 30);
    },
    hiddenTeleItemCount() {
      return Math.max(0, this.filteredTeleItems.length - 30);
    },
    shortBusinessScope() {
      const text = this.firstAiDetail.businessScope || this.firstAiDetail.companyInfo || "";
      return text.length > 30 ? text.slice(0, 30) + "..." : text;
    },
    mergedJudicialInfo() {
      return Array.from(new Set((this.aiDetailLeads || []).map((item) => item.judicialInfo).filter(Boolean))).join("\n");
    },
    mergedRiskInfo() {
      return Array.from(new Set((this.aiDetailLeads || []).map((item) => item.riskInfo).filter(Boolean))).join("\n");
    },
    currentTeleItem() {
      return this.tm.currentIndex >= 0
        ? this.tm.items[this.tm.currentIndex]
        : null;
    },

    disputeFieldsSchema() {
      return CRM_DISPUTE_SCHEMAS[this.form.disputeType] || [];
    },
    resultStatCards() {
      if (!this.importResult) return [];
      const { summary } = this.importResult;
      return [
        { label: "本次上传总条数", value: summary.total },
        { label: "实际可导入数量", value: summary.importable },
        { label: "与公海池重复", value: summary.publicDuplicate },
        { label: "与其他员工重复", value: summary.otherDuplicate },
        { label: "与我的客户重复", value: summary.selfDuplicate },
        { label: "文件内部重复", value: summary.innerDuplicate },
        { label: "手机号为空", value: summary.emptyPhone },
        { label: "手机号格式错误", value: summary.invalidPhone },
      ];
    },
  },
  created() {
    this.applyDisputeSchema(this.form.disputeType);
    this.loadLastImportResult();
    this.loadTeleItems();
  },
  methods: {
    apiData(res) {
      return (res && res.data) || {};
    },
    normalizeRows(rows) {
      return rows
        .map((row) => ({
          客户姓名: row["客户姓名"] || row["姓名"] || row.name || "",
          手机号: row["手机号"] || row["手机"] || row.phone || "",
          微信号: row["微信号"] || row["微信"] || row.wechat || "",
          公司名称: row["公司名称"] || row["公司"] || row.companyName || "",
          法人姓名: row["法人姓名"] || row["法人"] || row.legalPersonName || "",
          公司地址: row["公司地址"] || row["地址"] || row.companyAddress || "",
          地区: row["地区"] || row.region || "",
          问题类型: row["问题类型"] || row.issueType || "债务催收",
          备注: row["备注"] || row.remark || "",
        }))
        .filter((row) => row.手机号 || row.客户姓名);
    },
    handleTeleFilePick(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const rows = this.normalizeRows(
          XLSX.utils.sheet_to_json(sheet, { defval: "" })
        );
        if (!rows.length) {
          this.$message.warning("Excel 中未识别到可导入数据");
          return;
        }
        this.confirmTeleImport(rows, file.name);
      };
      reader.readAsArrayBuffer(file);
      event.target.value = "";
    },
    confirmTeleImport(rows, fileName) {
      this.tm.importing = true;
      postRequest("/crm/importConfirm", { rows, fileName })
        .then((res) => {
          if (res && res.code && Number(res.code) !== 200) {
            this.$message.error(res.msg || "导入失败");
            return;
          }
          const data = this.apiData(res);
          this.tm.lastBatch = data.batch || {};
          this.tm.items = data.items || data.imported || [];
          this.tm.currentIndex = this.tm.items.length ? 0 : -1;
          this.importResult = data;
          this.$message.success(`导入成功，已生成 ${this.tm.items.length} 条拨打任务`);
          if (this.tm.lastBatch.id) this.loadTeleItems();
          else if (this.tm.items.length) this.loadTeleItemDetail();
        })
        .finally(() => {
          this.tm.importing = false;
        });
    },
    loadTeleItems() {
      this.tm.loading = true;
      const params = {
        batchId: this.tm.lastBatch.id || 0,
        callStatus: this.tm.status,
      };
      postRequest("/crm/importItemList", params)
        .then((res) => {
          if (res && res.code && Number(res.code) !== 200) {
            this.$message.error(res.msg || "获取拨打队列失败");
            this.clearTeleDetail();
            return;
          }
          const data = this.apiData(res);
          this.tm.items = data.list || [];
          this.tm.stats = data.stats || this.tm.stats;
          if (!this.tm.items.length) {
            this.tm.currentIndex = -1;
            this.clearTeleDetail();
          } else {
            if (this.tm.currentIndex < 0 || this.tm.currentIndex >= this.tm.items.length) this.tm.currentIndex = 0;
            this.loadTeleItemDetail();
          }
        })
        .finally(() => {
          this.tm.loading = false;
        });
    },
    selectTeleItem(row) {
      const index = this.tm.items.findIndex((item) => item.id === row.id);
      this.tm.currentIndex = index >= 0 ? index : 0;
      this.loadTeleItemDetail();
    },
    moveTele(step) {
      if (!this.tm.items.length) return;
      const next = this.tm.currentIndex + step;
      if (next < 0 || next >= this.tm.items.length) {
        this.$message.info("没有更多客户了");
        return;
      }
      this.tm.currentIndex = next;
      this.loadTeleItemDetail();
    },
    skipTeleItem() {
      if (!this.currentTeleItem) return;
      this.moveTele(1);
    },
    completeTeleItem() {
      if (!this.currentTeleItem) return;
      if (!this.tm.follow.summary || this.tm.follow.summary.length < 20) {
        this.$message.warning("完成前请填写至少 20 个字的跟进备注");
        return;
      }
      this.tm.completing = true;
      const currentIndex = this.tm.currentIndex;
      postRequest("/crm/completeTelemarketingItem", {
        importItemId: this.currentTeleItem.id,
        result: this.tm.follow.result,
        summary: this.tm.follow.summary,
        nextFollowTime: this.tm.follow.nextFollowTime,
        intentionLevel: this.tm.follow.intentionLevel,
        valid: this.tm.follow.result !== "未接通" ? 1 : 0,
      })
        .then((res) => {
          if (res && res.code && Number(res.code) !== 200) {
            this.$message.error(res.msg || "完成任务失败");
            return;
          }
          this.$message.success("已完成当前号码并切换下一条");
          this.tm.follow.summary = "";
          this.tm.currentIndex = currentIndex;
          this.loadTeleItems();
        })
        .finally(() => {
          this.tm.completing = false;
        });
    },
    clearTeleDetail() {
      this.tm.detail = null;
      this.tm.callRecords = [];
      this.tm.followRecords = [];
      this.tm.ai.leads = [];
      this.tm.recentWarning = "";
    },
    loadTeleItemDetail() {
      if (!this.currentTeleItem) {
        this.clearTeleDetail();
        return;
      }
      this.tm.detailLoading = true;
      postRequest("/crm/telemarketingItemDetail", { importItemId: this.currentTeleItem.id })
        .then((res) => {
          const data = this.apiData(res);
          this.tm.detail = data.customer || null;
          this.tm.callRecords = data.callRecords || [];
          this.tm.followRecords = data.followRecords || [];
          this.tm.ai.leads = data.aiLeads || [];
          this.tm.recentWarning = data.recentWarning || "";
          if (data.customer) {
            const merged = Object.assign({}, this.currentTeleItem, {
              name: data.customer.name || this.currentTeleItem.name,
              phone: data.customer.phone || this.currentTeleItem.phone,
              companyName: data.customer.companyName || this.currentTeleItem.companyName,
              legalPersonName: data.customer.legalPersonName || this.currentTeleItem.legalPersonName,
              companyAddress: data.customer.companyAddress || this.currentTeleItem.companyAddress,
              region: data.customer.region || this.currentTeleItem.region,
              issueType: data.customer.issueType || this.currentTeleItem.issueType,
            });
            // 公海转入资源：合并画像字段到 detail
            if (this.currentTeleItem.queueSource === 'public_pool' && this.tm.detail) {
              const profile = data.publicProfile || {};
              this.tm.detail = Object.assign({}, this.tm.detail, {
                enterpriseScale:   profile.enterpriseScale   || data.customer.enterpriseScale   || '',
                tianyanScore:      profile.tianyanScore      || data.customer.tianyanScore      || 0,
                industryBig:       profile.industryBig       || data.customer.industryBig       || '',
                registerStatus:    profile.registerStatus    || data.customer.registerStatus    || '',
                registeredCapital: profile.registeredCapital || data.customer.registeredCapital || '',
                extraPhones:       profile.extraPhones       || data.customer.extraPhones       || [],
                businessScope:     profile.businessScope     || data.customer.businessScope     || '',
              });
            }
            this.$set(this.tm.items, this.tm.currentIndex, merged);
          }
        })
        .finally(() => {
          this.tm.detailLoading = false;
        });
    },
    filterTeleItems() {
      // 来源筛选变化时重置到第一条
      this.tm.currentIndex = -1;
      this.clearTeleDetail();
    },
    formatTeleDuration(seconds) {
      const value = parseInt(seconds || 0, 10);
      if (value <= 0) return "-";
      const minute = Math.floor(value / 60);
      const second = value % 60;
      return minute > 0 ? `${minute}分${second}秒` : `${second}秒`;
    },

    callTeleItem() {
      if (!this.currentTeleItem) return;
      this.tm.calling = true;
      postRequest("/crm/telemarketingCall", {
        importItemId: this.currentTeleItem.id,
      })
        .then(() => {
          this.$message.success("呼叫任务已推送到员工 APP");
          this.loadTeleItems();
        })
        .finally(() => {
          this.tm.calling = false;
        });
    },

    returnToPublicPool() {
      if (!this.currentTeleItem) return;
      this.$confirm('确认将此资源退回公海池？退回后该任务将从工作台移除，资源重新进入公海可被其他员工领取。', '退回公海', {
        confirmButtonText: '确认退回',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.tm.returning = true;
        postRequest('/crm/returnItemToPublicPool', {
          importItemId: this.currentTeleItem.id,
        }).then((res) => {
          if (res && res.code && Number(res.code) !== 200) {
            this.$message.error(res.msg || '退回失败');
            return;
          }
          this.$message.success('已退回公海池');
          this.loadTeleItems();
        }).finally(() => {
          this.tm.returning = false;
        });
      }).catch(() => {});
    },
    saveTeleFollow() {
      if (!this.currentTeleItem) return;
      if (!this.tm.follow.summary || this.tm.follow.summary.length < 20) {
        this.$message.warning("沟通摘要至少填写 20 个字");
        return;
      }
      this.tm.savingFollow = true;
      postRequest("/crm/saveFollow", {
        customerId: this.currentTeleItem.customerId,
        importItemId: this.currentTeleItem.id,
        method: "电话",
        result: this.tm.follow.result,
        summary: this.tm.follow.summary,
        nextFollowTime: this.tm.follow.nextFollowTime,
        intentionLevel: this.tm.follow.intentionLevel,
        valid: this.tm.follow.result !== "未接通" ? 1 : 0,
      })
        .then(() => {
          this.$message.success("跟进记录已保存");
          this.tm.follow.summary = "";
          this.moveTele(1);
        })
        .finally(() => {
          this.tm.savingFollow = false;
        });
    },
    searchAiPhoneLeads() {
      if (!this.currentTeleItem) return;
      this.tm.ai.searching = true;
      postRequest("/crm/aiPhoneLeads/search", { importItemId: this.currentTeleItem.id })
        .then((res) => {
          if (res && res.code && Number(res.code) !== 200) {
            this.$message.error(res.msg || "AI找号失败");
            return;
          }
          const data = this.apiData(res);
          this.tm.ai.leads = data.list || [];
          if (!this.tm.ai.leads.length) {
            const d = data.diagnostics || {};

            this.$message.warning(
              `AI找号未识别到号码。联网:${d.webSearchCount || 0}，通义:${(d.modelCounts && d.modelCounts['通义千问']) || 0}，DeepSeek:${(d.modelCounts && d.modelCounts['DeepSeek']) || 0}，豆包:${(d.modelCounts && d.modelCounts['豆包']) || 0}`
            );
          } else {
            this.$message.success(`AI找号完成，共 ${this.tm.ai.leads.length} 条线索`);
          }
        })
        .finally(() => {
          this.tm.ai.searching = false;
        });
    },
    openAiLeadDetail() {
      if (!this.currentTeleItem) return;
      this.aiDetailVisible = true;
      this.aiDetailLoading = true;
      postRequest("/crm/aiPhoneLeads/detail", { importItemId: this.currentTeleItem.id })
        .then((res) => {
          if (res && res.code && Number(res.code) !== 200) return this.$message.error(res.msg || "获取AI找号详情失败");
          const data = this.apiData(res);
          this.aiDetailCustomer = data.customer || {};
          this.aiDetailItem = data.item || {};
          this.aiDetailLeads = data.leads && data.leads.length ? data.leads : this.tm.ai.leads;
        })
        .finally(() => {
          this.aiDetailLoading = false;
        });
    },
    saveAiLead(lead) {
      postRequest("/crm/aiPhoneLeads/save", Object.assign({ importItemId: this.currentTeleItem && this.currentTeleItem.id }, lead)).then(() => {
        this.$message.success("线索已保存");
        this.loadTeleItemDetail();
      });
    },
    joinAiLeadQueue(lead) {
      postRequest("/crm/aiPhoneLeads/joinQueue", { leadId: lead.id, importItemId: this.currentTeleItem && this.currentTeleItem.id }).then((res) => {
        if (res && res.code && Number(res.code) !== 200) return this.$message.error(res.msg || "加入失败");
        this.$message.success("已加入拨打名单");
        this.loadTeleItems();
      });
    },
    callAiLead(lead) {
      postRequest("/crm/aiPhoneLeads/call", { leadId: lead.id, importItemId: this.currentTeleItem && this.currentTeleItem.id }).then((res) => {
        if (res && res.code && Number(res.code) !== 200) return this.$message.error(res.msg || "拨号失败");
        this.$message.success("AI线索号码已推送到员工APP");
        this.loadTeleItemDetail();
      });
    },
    ignoreAiLead(lead) {
      postRequest("/crm/aiPhoneLeads/save", Object.assign({}, lead, { id: lead.id, status: "已忽略", importItemId: this.currentTeleItem && this.currentTeleItem.id })).then(() => {
        this.$message.success("已忽略");
        this.loadTeleItemDetail();
      });
    },

    persistState() {
      saveCrmState(this.state);
      this.state = loadCrmState(this.ownerName);
    },
    restoreDemo() {
      this.state = resetCrmState(this.ownerName);
      this.mode = "single";
      this.form = emptyForm();
      this.applyDisputeSchema(this.form.disputeType);
      this.importResult = null;
      this.importFileName = "";
      window.localStorage.removeItem(IMPORT_RESULT_KEY);
      this.$message.success("CRM 模拟数据已恢复初始状态");
    },
    applyDisputeSchema(type) {
      const current = this.form.disputeFields || {};
      const next = {};
      (CRM_DISPUTE_SCHEMAS[type] || []).forEach((item) => {
        next[item.prop] = current[item.prop] || "";
      });
      this.form.disputeFields = next;
    },
    findDuplicateCustomer() {
      const phone = normalizePhone(this.form.phone);
      if (!phone) return null;
      return (
        (this.state.customers || []).find(
          (item) => normalizePhone(item.phone) === phone
        ) || null
      );
    },
    checkDuplicate() {
      const duplicate = this.findDuplicateCustomer();
      if (!duplicate) return;
      this.duplicateInfo = duplicate;
      this.duplicateVisible = true;
    },
    validateSingleForm() {
      if (!this.form.name || !normalizePhone(this.form.phone)) {
        this.$message.warning("客户姓名和正确手机号为必填项");
        return false;
      }
      if (!this.form.disputeType) {
        this.$message.warning("请先选择案件纠纷类型");
        return false;
      }
      return true;
    },
    saveDraft() {
      window.localStorage.setItem(
        "fdb-crm-registration-draft",
        JSON.stringify(this.form)
      );
      this.$message.success("草稿已保存到浏览器本地（前端演示）");
    },
    saveDraftFromDuplicate() {
      this.saveDraft();
      this.duplicateVisible = false;
    },
    buildCustomerPayload() {
      const now = formatNow();
      return {
        id: createCustomerId(this.state),
        name: this.form.name,
        gender: this.form.gender,
        phone: normalizePhone(this.form.phone),
        backupPhone: this.form.backupPhone,
        wechat: this.form.wechat,
        companyName: this.form.companyName,
        jobTitle: this.form.jobTitle,
        region: this.form.region,
        source: this.form.source,
        sourceDetail: this.form.sourceDetail,
        issueType: this.form.issueType,
        disputeType: this.form.disputeType,
        caseAmount: Number(this.form.caseAmount || 0),
        serviceNeed: this.form.serviceNeed,
        painPoint: this.form.painPoint,
        remark: this.form.remark,
        firstCallDone: this.form.firstCallDone,
        firstCallResult: this.form.firstCallResult,
        hasWeChat: this.form.hasWeChat,
        intentionLevel: this.form.intentionLevel,
        ownerName: this.ownerName,
        poolType: "私人池",
        mainStatus: this.form.firstCallDone ? "跟进中" : "新录入",
        subStatus: this.form.firstCallDone
          ? this.form.firstCallResult
          : "未接通",
        nextFollowTime: this.form.nextFollowTime,
        lastFollowTime: this.form.firstCallDone ? now : "",
        publicPoolCountdown:
          ((this.state.rules || {}).privatePool || {}).publicAfterDays || 7,
        enteredAt: now,
        currentRule: "新客户首次联系保护规则",
        warningTriggered: false,
        extendable: true,
        tags: ["客户登记"],
        businessTags: [],
        riskTags: [],
        manageTags: [],
        customTags: [],
        timeline: [
          {
            time: now,
            type: "客户登记",
            title: "创建成功",
            desc: `由 ${this.ownerName} 手动录入客户资料`,
            operator: this.ownerName,
          },
        ],
        attachments: [],
        approvals: [],
        wechatProgress: {
          sentRequest: this.form.hasWeChat,
          approved: this.form.hasWeChat,
          approvedAt: this.form.hasWeChat ? now : "",
          sentCase: false,
          sentQuote: false,
          sentCompanyIntro: false,
        },
        disputeFields: { ...this.form.disputeFields },
      };
    },
    submitSingle(continueEntry) {
      if (!this.validateSingleForm()) return;
      const duplicate = this.findDuplicateCustomer();
      if (duplicate) {
        this.duplicateInfo = duplicate;
        this.duplicateVisible = true;
        return;
      }
      const customer = this.buildCustomerPayload();
      this.state.customers.unshift(customer);
      this.state.operationLogs.unshift(
        createOperationLog(
          this.ownerName,
          "客户管理CRM",
          "新增客户",
          customer.name,
          "单条录入客户",
          "成功",
          customer.source
        )
      );
      this.persistState();
      this.$message.success(
        continueEntry
          ? "客户已录入，并已为你清空表单继续下一条"
          : "客户已加入我的客户（前端演示）"
      );
      this.form = emptyForm();
      this.applyDisputeSchema(this.form.disputeType);
      if (!continueEntry) {
        this.$router.push("/crm/my-customers");
      }
    },
    downloadTemplate() {
      const headers = [
        "客户姓名",
        "手机号",
        "微信号",
        "公司名称",
        "法人姓名",
        "公司地址",
        "地区",
        "问题类型",
        "备注",
      ];
      const rows = [
        headers,
        ["示例客户", "13800138000", "crm_demo_01", "示例公司", "张三", "福建省福州市鼓楼区示例路1号", "福建-福州", "债务催收", "模板示例：请保留表头，从第二行开始填写"],
      ];
      const worksheet = XLSX.utils.aoa_to_sheet(rows);
      worksheet["!cols"] = [
        { wch: 14 },
        { wch: 16 },
        { wch: 18 },
        { wch: 24 },
        { wch: 14 },
        { wch: 14 },
        { wch: 14 },
        { wch: 16 },
        { wch: 36 },
      ];
      worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "电销客户导入模板");
      XLSX.writeFile(workbook, "电销客户导入模板.xlsx");
      this.$message.success("导入模板已生成下载");
    },
    triggerUpload() {
      this.$refs.excelInput && this.$refs.excelInput.click();
    },
    loadLastImportResult() {
      const raw = window.localStorage.getItem(IMPORT_RESULT_KEY);
      this.importResult = raw ? JSON.parse(raw) : null;
    },
    handleFilePick(event) {
      const file = (event.target.files || [])[0];
      if (!file) return;
      this.importFileName = file.name;
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const workbook = XLSX.read(new Uint8Array(e.target.result), {
            type: "array",
          });
          const sheet = workbook.Sheets[workbook.SheetNames[0]];
          const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });
          this.importResult = evaluateImportRows(
            rows,
            this.state,
            this.ownerName
          );
          window.localStorage.setItem(
            IMPORT_RESULT_KEY,
            JSON.stringify(this.importResult)
          );
          this.$message.success(
            `预检完成，共识别 ${this.importResult.summary.total} 条数据`
          );
        } catch (error) {
          console.error(error);
          this.$message.error("文件解析失败，请检查格式");
        }
      };
      reader.readAsArrayBuffer(file);
      event.target.value = "";
    },
    viewLastImport() {
      if (!this.importResult) {
        this.$message.warning("当前没有导入结果，请先上传 Excel");
        return;
      }
      this.mode = "import";
      this.$message.success("已切换到最近一次导入结果");
    },
    clearImportResult() {
      this.importResult = null;
      this.importFileName = "";
      window.localStorage.removeItem(IMPORT_RESULT_KEY);
    },
    confirmImport() {
      if (!this.importResult || !this.importResult.accepted.length) {
        this.$message.warning("当前没有可导入数据");
        return;
      }
      const inserted = this.importResult.accepted.map((item) =>
        buildImportedCustomer(item, this.ownerName)
      );
      inserted.forEach((item) => {
        item.tags = ["Excel导入"];
        item.timeline = [
          {
            time: formatNow(),
            type: "Excel导入",
            title: "导入成功",
            desc: `由 ${this.ownerName} 通过 Excel 导入到我的客户`,
            operator: this.ownerName,
          },
        ];
      });
      this.state.customers = inserted.concat(this.state.customers || []);
      this.state.operationLogs.unshift(
        createOperationLog(
          this.ownerName,
          "客户管理CRM",
          "Excel导入",
          "批量客户",
          `导入 ${inserted.length} 条新客户`,
          "成功",
          this.importFileName
        )
      );
      this.persistState();
      this.$message.success(
        `导入完成，仅成功导入 ${inserted.length} 条完全新客户`
      );
    },
  },
};
</script>

<style scoped>
.crm-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.tm-workbench {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.tm-header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  padding: 12px 16px;
  min-height: 56px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #e8edf5;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.04);
}
.tm-title-row {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.tm-stats {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #4b5563;
  font-size: 13px;
}
.tm-stats b {
  color: #111827;
  font-size: 16px;
}
.tm-header h2 {
  margin: 0;
  font-size: 20px;
  color: #111827;
}
.tm-header p,
.muted {
  color: #6b7280;
  line-height: 1.7;
}
.tm-actions,
.tm-card-header,
.tm-callbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.tm-body {
  display: grid;
  grid-template-columns: 460px minmax(0, 1fr) 340px;
  gap: 14px;
}
.tm-list,
.tm-detail {
  min-height: 620px;
}
.tm-search {
  margin-bottom: 12px;
}
.tm-callbar {
  justify-content: center;
  margin: 18px 0 8px;
}

.tm-ai {
  min-height: 620px;
}
.ai-base {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px;
  margin-bottom: 10px;
  border-radius: 10px;
  background: #f8fbff;
  border: 1px solid #e0ebff;
}
.tm-list-fold {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #f8fafc;
  color: #6b7280;
  font-size: 12px;
}
.ai-phone-only {
  display: inline-block;
  color: #059669;
  font-size: 15px;
  letter-spacing: 0.3px;
}
.ai-detail-simple-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 12px;
}
.simple-row {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #edf2f7;
}
.simple-row span {
  color: #6b7280;
  font-size: 12px;
}
.simple-row b {
  color: #111827;
  line-height: 1.5;
  word-break: break-all;
}
.phone-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.ai-detail-window {
  max-height: 72vh;
  overflow: auto;
}
.ai-detail-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  padding: 4px 2px 12px;
  border-bottom: 1px solid #edf2f7;
}
.ai-detail-head span {
  display: block;
  margin-top: 4px;
  color: #6b7280;
  font-size: 12px;
}
.ai-detail-layout {
  display: grid;
  grid-template-columns: 42% 1fr;
  gap: 12px;
  margin-top: 12px;
}
.ai-detail-left,
.ai-detail-right {
  min-width: 0;
}
.ai-detail-card {
  margin-bottom: 10px;
  border-radius: 10px;
}
.ai-detail-card p {
  margin: 6px 0 0;
  color: #374151;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-all;
}
.ai-detail-card a {
  color: #2563eb;
  word-break: break-all;
}
.lead-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.ai-base span {
  color: #6b7280;
  font-size: 12px;
}
.ai-detail {
  margin-top: 6px;
  padding: 6px 8px;
  border-radius: 8px;
  background: #fff7ed;
  color: #4b5563;
  font-size: 12px;
  line-height: 1.55;
  word-break: break-all;
}
.ai-more-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  padding: 6px 8px;
  border-radius: 8px;
  background: #f8fafc;
  color: #6b7280;
  font-size: 12px;
}

.ai-detail a {
  color: #2563eb;
}
.ai-tags {
  margin-top: 4px;
}
.ai-tags .el-tag {
  margin: 2px 4px 0 0;
}

.ai-summary {
  margin-top: 6px;
  padding: 6px 8px;
  border-radius: 8px;
  background: #f9fafb;
  color: #374151;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-all;
}

.ai-table .el-button {
  padding: 2px 0;
}

.crm-hero {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  padding: 24px 28px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #e8edf5;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.04);
}
.crm-eyebrow {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(64, 158, 255, 0.12);
  color: #409eff;
  font-size: 12px;
  font-weight: 700;
}
.crm-hero h2 {
  margin: 12px 0 0;
  font-size: 28px;
  color: #111827;
}
.crm-hero p {
  margin: 10px 0 0;
  color: #6b7280;
  line-height: 1.7;
}
.crm-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.selected-dispute {
  margin-top: 16px;
  padding: 12px 14px;
  border-radius: 14px;
  background: #fff5f5;
  border: 1px solid #fecaca;
  color: #b91c1c;
}
.selected-dispute b {
  font-size: 16px;
}
.form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 16px;
  flex-wrap: wrap;
}
.import-box,
.template-box {
  min-height: 180px;
  border-radius: 16px;
  background: #f8fbff;
  border: 1px solid #e0ebff;
  padding: 18px;
}
.import-box h4,
.template-box h4 {
  margin: 0 0 12px;
  font-size: 16px;
  color: #111827;
}
.import-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.file-name {
  margin-top: 12px;
  color: #6b7280;
  font-size: 13px;
}
.template-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.template-box ul {
  margin: 0;
  padding-left: 18px;
  color: #4b5563;
  line-height: 1.8;
}
.result-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}
.result-card {
  padding: 16px 18px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid #e8edf5;
}
.result-card span {
  display: block;
  color: #6b7280;
  font-size: 13px;
}
.result-card strong {
  display: block;
  margin-top: 8px;
  font-size: 28px;
  color: #111827;
}
.confirm-tip {
  margin-top: 14px;
  padding: 12px 14px;
  border-radius: 14px;
  background: #fff8eb;
  border: 1px dashed #f5d38b;
  color: #9a6700;
  line-height: 1.8;
}
.duplicate-box {
  color: #374151;
  line-height: 1.8;
}
.duplicate-line {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 0;
  border-bottom: 1px solid #eef2f7;
}
.duplicate-line span {
  color: #6b7280;
}
.duplicate-tip {
  margin-top: 12px;
  color: #b45309;
}
.hidden-input {
  display: none;
}
@media (max-width: 1200px) {
  .crm-hero {
    flex-direction: column;
    align-items: flex-start;
  }
  .result-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 1200px) {
  .tm-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .tm-body {
    grid-template-columns: 1fr;
  }
}
.tm-scope-text {
  font-size: 12px;
  color: #606266;
  line-height: 1.6;
}
.tm-search {
  margin-bottom: 6px;
}
</style>
